import { Flex, Text, Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useLegalMentionsModalForm } from '../../../../../../../../../../context/legalMentionsModalFormContext'

const TEXT_AREA_ROWS_COUNT = 2
const CUSTOM_MENTION_MAX_TEXT = 250

export const LatePaymentPenaltyRateCustomMentionField = (): ReactElement => {
  const { t } = useTranslation()
  const { legalMentionsModalForm } = useLegalMentionsModalForm()
  const { FormItem, control } = legalMentionsModalForm

  const value = useWatch({
    control,
    name: 'custom.latePaymentPenaltyRate',
  })

  const length = value?.length ?? 0

  return (
    <FormItem
      name="custom.latePaymentPenaltyRate"
      label={
        <Flex justifyContent="space-between" alignItems="center">
          <Text variant="bodyLG" weight="medium">
            {t(
              'settings.organization.external_invoice.legal_mentions.modal.late_payment_penalty_rate.custom_mention_field.title',
            )}
          </Text>

          <Text variant="bodySM">
            {length}/{CUSTOM_MENTION_MAX_TEXT}
          </Text>
        </Flex>
      }
      render={({ field }) => (
        <Textarea
          {...field}
          value={field.value ?? ''}
          resizable
          rows={TEXT_AREA_ROWS_COUNT}
          maxLength={CUSTOM_MENTION_MAX_TEXT}
        />
      )}
    />
  )
}
